/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import ConfigureAndRun from './components/ConfigureAndRun';
import LastExecution from './components/LastExecution';
import AvailableTools from './components/AvailableTools';
import {
  Wrapper, Title,
  CardMain, CardFooter, Header, FaradayLogo,
  CustomStatus, DescriptionContent
} from './styled';
import { selectRow } from 'store/Agents/actions';
import Categories from './components/Categories';

const UserAgent = memo(({ data: { agent, selected } }) => {
  const intl = useIntl();
  const name = get(agent, 'name', '');
  const lastExecution = get(agent, 'last_run', null);
  const tools = get(agent, 'executors', []);
  const status = get(agent, 'status', 'offline');
  const description = get(agent, 'description', '');
  const categories = [...new Set(tools.flatMap(el => el.category || []).filter(c => c !== null))];
  const tool = get(agent, 'last_run_executor', '');
  const dispatch = useDispatch();
  const statusLabel = intl.formatMessage({ id: `agents.item.status.${status}` });
  const noDescription = intl.formatMessage({ id: 'agents.item.description.none' });

  const handleSelect = (e) => {
    dispatch(selectRow(e, agent));
  };

  return (
    <Wrapper selected={ selected } onClick={ handleSelect }>
      <CardMain>
        <Header>
          <FaradayLogo />
          <Title children={ name } />
          <CustomStatus value={ status } children={ statusLabel } />
        </Header>
        <DescriptionContent isEmpty={ !description } title={ description || undefined }>
          { description || noDescription }
        </DescriptionContent>
        <Categories data={ categories } />
      </CardMain>
      <CardFooter>
        <LastExecution lastExecution={ lastExecution } tool={ tool } />
        <AvailableTools tools={ tools } />
        <ConfigureAndRun agent={ agent } />
      </CardFooter>
    </Wrapper>
  );
});

UserAgent.displayName = 'UserAgent';

UserAgent.propTypes = {
  data: PropTypes.shape({
    agent: PropTypes.object.isRequired,
    selected: PropTypes.bool
  }).isRequired
};

export default UserAgent;
